"use strict";

var _slicedToArray = require("/home/circleci/repo/web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var util_1 = require("./util");

var defaultState = {
  acceleration: {
    x: null,
    y: null,
    z: null
  },
  accelerationIncludingGravity: {
    x: null,
    y: null,
    z: null
  },
  rotationRate: {
    alpha: null,
    beta: null,
    gamma: null
  },
  interval: 16
};

var useMotion = function useMotion() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;

  var _react_1$useState = react_1.useState(initialState),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  react_1.useEffect(function () {
    var handler = function handler(event) {
      var acceleration = event.acceleration,
          accelerationIncludingGravity = event.accelerationIncludingGravity,
          rotationRate = event.rotationRate,
          interval = event.interval;
      setState({
        acceleration: {
          x: acceleration.x,
          y: acceleration.y,
          z: acceleration.z
        },
        accelerationIncludingGravity: {
          x: accelerationIncludingGravity.x,
          y: accelerationIncludingGravity.y,
          z: accelerationIncludingGravity.z
        },
        rotationRate: {
          alpha: rotationRate.alpha,
          beta: rotationRate.beta,
          gamma: rotationRate.gamma
        },
        interval: interval
      });
    };

    util_1.on(window, 'devicemotion', handler);
    return function () {
      util_1.off(window, 'devicemotion', handler);
    };
  }, [0]);
  return state;
};

exports.default = useMotion;